import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/pluss_icon.svg'
import _imports_1 from '@/assets/images/expand_more.svg'


const _hoisted_1 = { class: "task-main-block-list" }
const _hoisted_2 = { class: "main-top-div-list" }
const _hoisted_3 = { class: "task-title-list" }
const _hoisted_4 = { class: "searchbar-wrapper" }
const _hoisted_5 = { class: "search-bar-first-row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "time-entry-button-list-image",
  src: _imports_0
}, null, -1)
const _hoisted_7 = { class: "time-entry-button-list-text medium-text" }
const _hoisted_8 = {
  key: 2,
  class: "time-entry-dropdown-button"
}
const _hoisted_9 = { class: "search-bar-second-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  class: "time-entry-button-list-image",
  src: _imports_0
}, null, -1)
const _hoisted_11 = { class: "default-text" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  class: "time-entry-button-list-image",
  src: _imports_0
}, null, -1)
const _hoisted_13 = { class: "default-text" }
const _hoisted_14 = {
  key: 2,
  class: "hide-block"
}
const _hoisted_15 = {
  key: 3,
  class: "empty-state-div-list"
}
const _hoisted_16 = { class: "medium-text" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "empty-state-block-list" }, null, -1)
const _hoisted_18 = {
  key: 4,
  class: "task-item-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_asana_popup = _resolveComponent("asana-popup")!
  const _component_search_bar = _resolveComponent("search-bar")!
  const _component_chip_filter = _resolveComponent("chip-filter")!
  const _component_check_box = _resolveComponent("check-box")!
  const _component_task_item_header = _resolveComponent("task-item-header")!
  const _component_task_item = _resolveComponent("task-item")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isIntegrated && _ctx.showPopup && !_ctx.hideDivWhileLoading)
      ? (_openBlock(), _createBlock(_component_asana_popup, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.$t("component-task-list.my-tasks")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.checkIfTaskInfoPresent && !_ctx.hideDivWhileLoading)
            ? (_openBlock(), _createBlock(_component_search_bar, {
                key: 0,
                class: "search-bar-block",
                onSearchItem: _ctx.searchItem
              }, null, 8, ["onSearchItem"]))
            : _createCommentVNode("", true),
          (!_ctx.hideDivWhileLoading)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["time-entry-button-list", {
              'button-disabled':
                _ctx.tasks.length === 0 && _ctx.uniqueProjectFilter.length === 0,
            }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createNewTask()))
              }, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("component-task-list.new-entry")), 1)
              ], 2))
            : _createCommentVNode("", true),
          (!_ctx.hideDivWhileLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: _imports_1,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTaskListDropdown()))
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            onClickout: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hideDropdown = true)),
            class: _normalizeClass(["task-list-creation-dropdown", { hideElement: _ctx.hideDropdown }])
          }, [
            _createElementVNode("div", {
              class: "task-list-creation-dropdown-object",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createNewProject()))
            }, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("component-task-list.new-project")), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["task-list-creation-dropdown-object", { disabledSelection: _ctx.enableObjectiveSelection }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.createNewTaObjective()))
            }, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("component-task-list.new-objective")), 1)
            ], 2)
          ], 34)
        ])
      ]),
      (!_ctx.hideDivWhileLoading)
        ? (_openBlock(), _createBlock(_component_chip_filter, {
            key: 0,
            filterableArray: _ctx.uniqueProjectFilter,
            filterArray: "",
            filterName: _ctx.projectFilterText,
            onClearFilter: _ctx.clearprojects,
            onSelected: _ctx.projectFilterUpdate
          }, null, 8, ["filterableArray", "filterName", "onClearFilter", "onSelected"]))
        : _createCommentVNode("", true),
      (!_ctx.hideDivWhileLoading)
        ? (_openBlock(), _createBlock(_component_chip_filter, {
            key: 1,
            filterableArray: _ctx.uniqueTagFilter,
            filterName: _ctx.taskFilterText,
            onClearFilter: _ctx.clearFilters,
            onSelected: _ctx.taskFilterUpdate
          }, null, 8, ["filterableArray", "filterName", "onClearFilter", "onSelected"]))
        : _createCommentVNode("", true),
      (_ctx.checkIfTaskInfoPresent && !_ctx.hideDivWhileLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_check_box, {
              checkboxText: _ctx.statusText,
              checkActive: _ctx.showStatusCheck,
              size: 'default',
              onToggleCheckBox: _ctx.toggleStatus
            }, null, 8, ["checkboxText", "checkActive", "onToggleCheckBox"]),
            _createVNode(_component_check_box, {
              checkboxText: _ctx.priorityText,
              checkActive: _ctx.showPriorityCheck,
              size: 'default',
              onToggleCheckBox: _ctx.togglePriority
            }, null, 8, ["checkboxText", "checkActive", "onToggleCheckBox"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.checkIfTaskInfoPresent && !_ctx.hideDivWhileLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("component-task-list.empty-state")), 1),
            _hoisted_17
          ]))
        : _createCommentVNode("", true),
      (!_ctx.hideDivWhileLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filter, (maptask, indexTwo) => {
              return (_openBlock(), _createElementBlock("div", { key: indexTwo }, [
                _createVNode(_component_task_item_header, { taskDate: indexTwo }, null, 8, ["taskDate"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(maptask, (task, indexThree) => {
                  return (_openBlock(), _createBlock(_component_task_item, {
                    key: indexThree,
                    task: task,
                    showStatus: _ctx.showStatusCheck,
                    showPriority: _ctx.showPriorityCheck,
                    showFirstElement: true,
                    onNewTimeEntry: _ctx.createNewTimeEntry,
                    onViewTaskInfo: _ctx.viewTimeEntry
                  }, null, 8, ["task", "showStatus", "showPriority", "onNewTimeEntry", "onViewTaskInfo"]))
                }), 128))
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}